import { env } from 'shared/config';
import { getToken } from 'shared/keycloak';
import { Method } from './constants';

type FetcherParams = {
  path: string;
  method?: Method;
  body?: unknown;
  formData?: FormData;
  headers?: Record<string, string>;
};

export const fetcher = async <T>({ path, method = Method.Get, body, formData, headers }: FetcherParams): Promise<T> => {
  const token = await getToken();

  const options: RequestInit = {
    method,
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  };

  if (body) {
    options.body = JSON.stringify(body);
  }
  if (formData) {
    options.body = formData;
    options.headers = { ...options.headers, 'Content-Type': 'application/json;charset=utf-8' };
  }
  if (headers) {
    options.headers = { ...options.headers, ...headers };
  }

  const response = await fetch(`${env.API_URL}${path}`, options);

  let data: T;
  try {
    data = await response.json();
  } catch (e) {
    console.error(e);
    data = {} as T;
  }

  if (!response.ok) {
    throw data;
  }

  return data;
};
